const initualState = {
  input: {
    to: new Date(),
    from: new Date()
  }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "CHANGE_SCHEDULE_SUBMISSION_INPUT":
      return { ...state, input: { ...state.input, ...action.payload } };
    default:
      return state;
  }
};
